var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.phone
    ? _c(_setup.InfoCard, {
        staticClass: "text-decoration-none",
        attrs: {
          icon: "ui-icon-ui-call",
          title: `${_setup.tStatic("Телефон")}:`,
          subtitle: _setup.formatPhone({
            phone: _setup.phone,
            country: _setup.context.request.country,
          }),
          href: _setup.isMobile
            ? `tel:${_setup.formatPhone({
                phone: _setup.phone,
                country: _setup.context.request.country,
                isRaw: true,
              })}`
            : undefined,
        },
        on: {
          click: function ($event) {
            _setup.isMobile
              ? _setup.sendYaGoal("mobile_appointment__phone_action")
              : null
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }